import styled from 'styled-components';

export const OverlayListContainer = styled.div<{ $padTop?: number; $padBottom?: number; $padHorizontal?: number }>`
  padding-top: ${({ $padTop }) => $padTop || 0}px;
  padding-bottom: ${({ $padBottom }) => $padBottom || 0}px;
  padding-left: ${({ $padHorizontal }) => $padHorizontal || 0}px;
  padding-right: ${({ $padHorizontal }) => $padHorizontal || 0}px;
  gap: 16px;
  display: flex;
  flex-direction: column;
`;
